import { render, staticRenderFns } from "./icon_arrow.vue?vue&type=template&id=2ce85d9d"
import script from "./icon_arrow.vue?vue&type=script&lang=js"
export * from "./icon_arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports